import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ExampleComponent} from './example.component';

const routes: Routes = [
  {
    path: 'example', component: ExampleComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, enableTracing: false })],
  exports: [RouterModule]
})
export class ExampleRoutingModule {
}
